import { createTheme } from '@mui/material/styles';

export const BORDER_RADIUS = 20;
const theme = createTheme({
  palette: {
    primary: {
      main: '#101828',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
    greenChip: {
      contrastText: '#5ccc09',
      main: '#eaf9e0',
    },
    redChip: {
      contrastText: '#ff595d',
      main: '#ffe9ea',
    },
    orangeChip: {
      contrastText: '#ff595d',
      main: '#ffebc7',
    },
    yellowChip: {
      contrastText: '#ff595d',
      main: '#fff9db',
    },
  },

  typography: {
    fontFamily: 'Roboto, sans-serif',
  },

  shape: {
    borderRadius: 8,
  },

  spacing: 8,

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },

  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: BORDER_RADIUS,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'primary.main',
        },
      },
    },
  },
});

export default theme;
